/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Height_ShortInputs */

const en_us2_intake_why_height_short = /** @type {(inputs: Intake_Why_Height_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Part of the body-mass picture`)
};

const pt_br2_intake_why_height_short = /** @type {(inputs: Intake_Why_Height_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte do quadro corporal`)
};

const es_419_intake_why_height_short = /** @type {(inputs: Intake_Why_Height_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte del cuadro corporal`)
};

const pt_pt2_intake_why_height_short = /** @type {(inputs: Intake_Why_Height_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte do quadro corporal`)
};

const fr_fr2_intake_why_height_short = /** @type {(inputs: Intake_Why_Height_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fait partie du profil corporel`)
};

const de_de2_intake_why_height_short = /** @type {(inputs: Intake_Why_Height_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teil des Körperbilds`)
};

const it_it2_intake_why_height_short = /** @type {(inputs: Intake_Why_Height_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte del quadro corporeo`)
};

/**
* | output |
* | --- |
* | "Part of the body-mass picture" |
*
* @param {Intake_Why_Height_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_height_short = /** @type {((inputs?: Intake_Why_Height_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Height_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_height_short(inputs)
	if (locale === "es-419") return es_419_intake_why_height_short(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_height_short(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_height_short(inputs)
	if (locale === "de-DE") return de_de2_intake_why_height_short(inputs)
	if (locale === "it-IT") return it_it2_intake_why_height_short(inputs)
	return en_us2_intake_why_height_short(inputs)
});
export { intake_why_height_short as "intake.why.height.short" }